import { useAtomValue } from 'jotai';
import { hasCouplesUsuallySpendAtom } from '../jotai/storefront/shared-pricing';

export const useStorefrontCouplesUsuallySpend = (): boolean => {
	return useAtomValue(hasCouplesUsuallySpendAtom);
};
